export default __webpack_public_path__ + "53f59b80b65d20df580aa5776a4e9c85.png";